import React from 'react';
import Video from '../components/Video';
import Footer from '../components/Footer';
import Navbar2 from '../components/Navbar2';

function Home() {
  return (
    <div>
      <Navbar2 />
      <Video />
      <Footer />
    </div>
  )
}

export default Home
